import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/fp/cloneDeep';
import moment from 'moment';
import { ProductMap } from '@/utils/productMap';
import Enums, { SpotlightConstants, AVRProducts } from './utils/enums';
import helperFunctions from '@/utils/helperFunctions';

export const provinceMixin = {
  data() {
    const locale = this.$route.query.language;
    return {
      provinces: [
        this.$t('message.common.provinces.ontario', locale),
        this.$t('message.common.provinces.alberta', locale),
        this.$t('message.common.provinces.BC', locale),
        this.$t('message.common.provinces.manitoba', locale),
        this.$t('message.common.provinces.newBrunswick', locale),
        this.$t('message.common.provinces.newfoundLab', locale),
        this.$t('message.common.provinces.novaScotia', locale),
        this.$t('message.common.provinces.pei', locale),
        this.$t('message.common.provinces.quebec', locale),
        this.$t('message.common.provinces.saskatchewan', locale),
        this.$t('message.common.provinces.northwestTerritories', locale),
        this.$t('message.common.provinces.yukon', locale),
        this.$t('message.common.provinces.nunavut', locale),
      ],
    };
  },
  methods: {
    getProvinceCode(province) {
      let provinceCode = '';
      switch (province) {
        case this.$t('message.common.provinces.ontario'):
          provinceCode = 'ON';
          break;
        case this.$t('message.common.provinces.alberta'):
          provinceCode = 'AB';
          break;
        case this.$t('message.common.provinces.BC'):
          provinceCode = 'BC';
          break;
        case this.$t('message.common.provinces.manitoba'):
          provinceCode = 'MB';
          break;
        case this.$t('message.common.provinces.newBrunswick'):
          provinceCode = 'NB';
          break;
        case this.$t('message.common.provinces.newfoundLab'):
          provinceCode = 'NL';
          break;
        case this.$t('message.common.provinces.novaScotia'):
          provinceCode = 'NS';
          break;
        case this.$t('message.common.provinces.pei'):
          provinceCode = 'PE';
          break;
        case this.$t('message.common.provinces.quebec'):
          provinceCode = 'QC';
          break;
        case this.$t('message.common.provinces.saskatchewan'):
          provinceCode = 'SK';
          break;
        case this.$t('message.common.provinces.northwestTerritories'):
          provinceCode = 'NT';
          break;
        case this.$t('message.common.provinces.yukon'):
          provinceCode = 'YT';
          break;
        case this.$t('message.common.provinces.nunavut'):
          provinceCode = 'NU';
          break;
        default:
          provinceCode = 'error';
      }
      return provinceCode;
    },
  },
};
export const stateMixin = {
  data() {
    const locale = this.$route.query.language;
    return {
      states: [
        this.$t('message.common.states.alabama', locale),
        this.$t('message.common.states.alaska', locale),
        this.$t('message.common.states.arizona', locale),
        this.$t('message.common.states.arkansas', locale),
        this.$t('message.common.states.california', locale),
        this.$t('message.common.states.colorado', locale),
        this.$t('message.common.states.connecticut', locale),
        this.$t('message.common.states.delaware', locale),
        this.$t('message.common.states.districtOfColumbia', locale),
        this.$t('message.common.states.florida', locale),
        this.$t('message.common.states.georgia', locale),
        this.$t('message.common.states.hawaii', locale),
        this.$t('message.common.states.idaho', locale),
        this.$t('message.common.states.illinois', locale),
        this.$t('message.common.states.indiana', locale),
        this.$t('message.common.states.iowa', locale),
        this.$t('message.common.states.kansas', locale),
        this.$t('message.common.states.kentucky', locale),
        this.$t('message.common.states.louisiana', locale),
        this.$t('message.common.states.maine', locale),
        this.$t('message.common.states.maryland', locale),
        this.$t('message.common.states.massachusetts', locale),
        this.$t('message.common.states.michigan', locale),
        this.$t('message.common.states.minnesota', locale),
        this.$t('message.common.states.mississippi', locale),
        this.$t('message.common.states.missouri', locale),
        this.$t('message.common.states.montana', locale),
        this.$t('message.common.states.nebraska', locale),
        this.$t('message.common.states.nevada', locale),
        this.$t('message.common.states.newHampshire', locale),
        this.$t('message.common.states.newJersey', locale),
        this.$t('message.common.states.newMexico', locale),
        this.$t('message.common.states.newYork', locale),
        this.$t('message.common.states.northCarolina', locale),
        this.$t('message.common.states.northDakota', locale),
        this.$t('message.common.states.ohio', locale),
        this.$t('message.common.states.oklahoma', locale),
        this.$t('message.common.states.oregon', locale),
        this.$t('message.common.states.pennsylvania', locale),
        this.$t('message.common.states.rhodeIsland', locale),
        this.$t('message.common.states.southCarolina', locale),
        this.$t('message.common.states.southDakota', locale),
        this.$t('message.common.states.tennessee', locale),
        this.$t('message.common.states.texas', locale),
        this.$t('message.common.states.utah', locale),
        this.$t('message.common.states.vermont', locale),
        this.$t('message.common.states.virginia', locale),
        this.$t('message.common.states.washington', locale),
        this.$t('message.common.states.westVirginia', locale),
        this.$t('message.common.states.wisconsin', locale),
        this.$t('message.common.states.wyoming', locale),
      ],
    };
  },
  methods: {
    getStateCode(state) {
      let stateCode = '';
      switch (state) {
        case this.$t('message.common.states.alabama'):
          stateCode = 'AL';
          break;
        case this.$t('message.common.states.alaska'):
          stateCode = 'AK';
          break;
        case this.$t('message.common.states.arizona'):
          stateCode = 'AZ';
          break;
        case this.$t('message.common.states.arkansas'):
          stateCode = 'AR';
          break;
        case this.$t('message.common.states.california'):
          stateCode = 'CA';
          break;
        case this.$t('message.common.states.colorado'):
          stateCode = 'CO';
          break;
        case this.$t('message.common.states.connecticut'):
          stateCode = 'CT';
          break;
        case this.$t('message.common.states.delaware'):
          stateCode = 'DE';
          break;
        case this.$t('message.common.states.districtOfColumbia'):
          stateCode = 'DC';
          break;
        case this.$t('message.common.states.florida'):
          stateCode = 'FL';
          break;
        case this.$t('message.common.states.georgia'):
          stateCode = 'GA';
          break;
        case this.$t('message.common.states.hawaii'):
          stateCode = 'HI';
          break;
        case this.$t('message.common.states.idaho'):
          stateCode = 'ID';
          break;
        case this.$t('message.common.states.illinois'):
          stateCode = 'IL';
          break;
        case this.$t('message.common.states.indiana'):
          stateCode = 'IN';
          break;
        case this.$t('message.common.states.iowa'):
          stateCode = 'IA';
          break;
        case this.$t('message.common.states.kansas'):
          stateCode = 'KS';
          break;
        case this.$t('message.common.states.kentucky'):
          stateCode = 'KY';
          break;
        case this.$t('message.common.states.louisiana'):
          stateCode = 'LA';
          break;
        case this.$t('message.common.states.maine'):
          stateCode = 'ME';
          break;
        case this.$t('message.common.states.maryland'):
          stateCode = 'MD';
          break;
        case this.$t('message.common.states.massachusetts'):
          stateCode = 'MA';
          break;
        case this.$t('message.common.states.michigan'):
          stateCode = 'MI';
          break;
        case this.$t('message.common.states.minnesota'):
          stateCode = 'MN';
          break;
        case this.$t('message.common.states.mississippi'):
          stateCode = 'MS';
          break;
        case this.$t('message.common.states.missouri'):
          stateCode = 'MO';
          break;
        case this.$t('message.common.states.montana'):
          stateCode = 'MT';
          break;
        case this.$t('message.common.states.nebraska'):
          stateCode = 'NE';
          break;
        case this.$t('message.common.states.nevada'):
          stateCode = 'NV';
          break;
        case this.$t('message.common.states.newHampshire'):
          stateCode = 'NH';
          break;
        case this.$t('message.common.states.newJersey'):
          stateCode = 'NJ';
          break;
        case this.$t('message.common.states.newMexico'):
          stateCode = 'NM';
          break;
        case this.$t('message.common.states.newYork'):
          stateCode = 'NY';
          break;
        case this.$t('message.common.states.northCarolina'):
          stateCode = 'NC';
          break;
        case this.$t('message.common.states.northDakota'):
          stateCode = 'ND';
          break;
        case this.$t('message.common.states.ohio'):
          stateCode = 'OH';
          break;
        case this.$t('message.common.states.oklahoma'):
          stateCode = 'OK';
          break;
        case this.$t('message.common.states.oregon'):
          stateCode = 'OR';
          break;
        case this.$t('message.common.states.pennsylvania'):
          stateCode = 'PA';
          break;
        case this.$t('message.common.states.rhodeIsland'):
          stateCode = 'RI';
          break;
        case this.$t('message.common.states.southCarolina'):
          stateCode = 'SC';
          break;
        case this.$t('message.common.states.southDakota'):
          stateCode = 'SD';
          break;
        case this.$t('message.common.states.tennessee'):
          stateCode = 'TN';
          break;
        case this.$t('message.common.states.texas'):
          stateCode = 'TX';
          break;
        case this.$t('message.common.states.utah'):
          stateCode = 'UT';
          break;
        case this.$t('message.common.states.vermont'):
          stateCode = 'VT';
          break;
        case this.$t('message.common.states.virginia'):
          stateCode = 'VI';
          break;
        case this.$t('message.common.states.washington'):
          stateCode = 'WA';
          break;
        case this.$t('message.common.states.westVirginia'):
          stateCode = 'WV';
          break;
        case this.$t('message.common.states.wisconsin'):
          stateCode = 'WI';
          break;
        case this.$t('message.common.states.wyoming'):
          stateCode = 'WY';
          break;
        default:
          stateCode = 'error';
      }
      return stateCode;
    },
  },
};
export const routingMixin = {
  computed: {
    showBlocks() {
      return this.$route.meta.showBlocks;
    },
    isAVRDesktop() {
      return this.baseRoute === 'desktop';
    },
    isAVRMobile() {
      return this.baseRoute === 'mobile';
    },
    isAVREmbed() {
      return this.baseRoute === 'embed';
    },
    baseRoute() {
      if (this.$route.path.includes('/embed/')) {
        return 'embed';
      }
      if (this.$route.path.includes('/desktop/')) {
        return 'desktop';
      }
      return 'mobile';
    },
    hasSpotlightGetReportFooter() {
      return !!this.$route.path.includes('/spotlight/categories/');
    },
    homeRoute() {
      const countryPrefix = this.$route.params.country ? '/us' : '';
      return `${countryPrefix}/${this.baseRoute}/home`;
    },
    isSpotlightReport() {
      return this.$route.meta.spotlightReport;
    },
    categoryBaseRoute() {
      const route = `/categories/${this.$route.meta.category}`;
      if (this.isSpotlightReport) {
        return route;
      }
      return `/${this.baseRoute}/spotlight${route}`;
    },
    currentRoutePath() {
      return this.$route.path;
    },
    isUSRoute() {
      return this.$route.path.includes('/us/');
    },
    currentSubFlow() {
      return helperFunctions.currentSubFlow(this.$route.path);
    },
    ecomFlowSelected() {
      const flowSelected = helperFunctions.ecomFlowSelected(this.$route.path);
      if (typeof flowSelected === 'string') {
        return flowSelected;
      }
      return this.$store.state.ecommerceV2.flowSelected;
    },
    // If we already have a personalized credit score that means the user
    // has successfully gone through the personal
    // info pages so we don't need to show those
    // screens again for finance flow
    creditComplete() {
      return this.$store.state.credit.creditScore.creditGrade || this.$store.state.credit.regionalCreditScore;
    },
    contactFormInfoComplete() {
      return (
        this.$store.state.user.firstName &&
        this.$store.state.user.lastName &&
        this.$store.state.user.phoneNumber &&
        this.$store.state.user.emailAddress &&
        this.$store.state.user.postalCode
      );
    },
    nativeMobileIntegrationWithNoDeepLink() {
      return this.$store.getters.nativeMobileIntegration && this.$store.getters.nativeMobileDeepLink === null;
    },
    hideAllCloseBtns() {
      return (
        this.isAVREmbed || this.$route.query.standAloneApp === 'true' || this.nativeMobileIntegrationWithNoDeepLink
      );
    },
    hideAllHomeBtns() {
      return (
        this.$store.getters['business/isKijijiDealer'] ||
        this.$route.query.returnToFinanceApp === 'true' ||
        this.$store.getters.getCurrentProduct === AVRProducts.ACQUIRE
      );
    },
    isEcomV2() {
      return this.$store.getters.getCurrentProduct === AVRProducts.ECOMV2;
    },
    isBuildAndPrice() {
      return this.$store.getters.getCurrentProduct === AVRProducts.BUILD_AND_PRICE;
    },
  },
  methods: {
    getProductBasePath(product = false) {
      const countryPrefix = this.$route.params.country ? '/us' : '';
      let productRoute = product;
      if (!productRoute) {
        const productName = this.$store.getters.getCurrentProduct;
        const productData = ProductMap.filter(value => value.name === productName);
        productRoute = productData && productData[0] ? productData[0].route : null;
      }
      return `${countryPrefix}/${this.baseRoute}/${productRoute}`;
    },
    getNumberOfStepsForProgress() {
      if (this.$route.meta && this.$route.meta.numberOfSteps) {
        return this.$route.meta.numberOfSteps;
      }
      if (this.$route.meta && this.$route.meta.navInfo && !this.$route.meta.numberOfSteps) {
        if (this.currentSubFlow === 'finance') {
          if (this.creditComplete) {
            return 6;
          }
          return 10;
        }
      }
      return null;
    },
    getNextRoutePath() {
      if (this.$route.meta && this.$route.meta.hasNext) {
        if (this.$route.meta.nextRoutePath) {
          return this.$route.meta.nextRoutePath;
        }

        const thisIsEcom = this.$store.getters.getCurrentProduct === AVRProducts.ECOMV2;
        const basePath = this.getProductBasePath();
        const baseSubFlowPath = thisIsEcom ? `${basePath}/${this.ecomFlowSelected}` : basePath;
        switch (this.currentRoutePath) {
          // ------------ Ecom -----------
          // ----- Common routes
          case `${basePath}/select-e-commerce-flow`:
            return baseSubFlowPath;

          // ----- Personalized payments
          case `${basePath}/personalized-payment/trade-in-form`:
            return this.$store.state.paymentCalculator.hasTradeIn === 'yes' ? 'carfax-basic-form' : 'contact-info-form';

          // If we have questions from TransUnion go to the verify form
          case `${basePath}/personalized-payment/step-three`:
            return this.$store.state.credit.questionData.questions ? 'verify-credit-form' : 'payment-calculator';

          // ------------ Ecom and B&P -----------
          // ----- Credit sub flow
          // If we have a credit score from RCS, navigate to credit results page
          case `${baseSubFlowPath}/credit/confirm-credit-form`:
            return this.$store.state.credit.regionalCreditScore ? 'credit-results' : 'verify-credit-form';

          // ----- Finance flow
          // Skips screens if we already have successfully gone through credit
          case `${baseSubFlowPath}/finance/rent-or-own-form`:
            return this.creditComplete ? 'finance-thank-you' : 'address-form';

          // ---- Trade in sub flow
          // Only show contact form page if we don't have the data yet or a lead
          case `${baseSubFlowPath}/trade-in/trade-in-amount-owing-form`:
            if (this.contactFormInfoComplete && this.$store.getters['lead/leadIsActive']) {
              return this.$store.state.trade.tradein.tradeVehicleOutOfRange === true ||
                !this.$store.state.trade.tradein.trade_in_value.high_value
                ? 'trade-in-error'
                : 'trade-in-results';
            }
            return 'trade-in-contact-form';

          // If trade vehicle is out or range, or we do not have a trade report, display error state
          case `${baseSubFlowPath}/trade-in/trade-in-contact-form`:
            return this.$store.state.trade.tradein.tradeVehicleOutOfRange === true ||
              !this.$store.state.trade.tradein.trade_in_value.high_value
              ? 'trade-in-error'
              : 'trade-in-results';

          // ---- Personalized Payments flow for ecom
          // If trade, check for Vehicle out of range, else go to step two
          case `${basePath}/personalized-payment/contact-info-form`:
            if (this.$store.state.trade.tradein.tradeVehicleOutOfRange === true) {
              return 'trade-in-error';
            }
            if (
              this.$store.state.paymentCalculator.hasTradeIn === 'yes' &&
              this.$store.state.trade.tradein.trade_in_value.high_value
            ) {
              return 'trade-in-results';
            }
            return 'step-two';

          // ----- Payment calculator for ecom, payment summary for B&P
          case `${baseSubFlowPath}/trade-in/trade-in-results`:
          case `${baseSubFlowPath}/trade-in/trade-in-error`:
          case `${baseSubFlowPath}/trade-in/error`:
          case `${baseSubFlowPath}/finance/error`:
          case `${baseSubFlowPath}/credit/credit-results`:
          case `${baseSubFlowPath}/credit/credit-error`:
          case `${baseSubFlowPath}/credit/error`:
            return thisIsEcom ? '../payment-calculator' : '../payment-summary';

          default:
            return null;
        }
      }
      return null;
    },
    goToAVFinanceFlow(vehicle) {
      if (vehicle) {
        this.$store.commit('credit/SET_STATE', ['CIMFinanceApplicationVehicle', vehicle]);
      } else {
        this.$store.commit('credit/SET_STATE', ['CIMFinanceApplicationVehicle', null]);
      }
      if (this.$store.state.business.info.creditSettings.enableSSNCapture === true) {
        this.$router.push({
          name: `social-security-${this.baseRoute}`,
        });
      } else {
        this.$router.push({
          name: `finance-application-${this.baseRoute}`,
        });
      }
    },
    goToErrorPage() {
      const route = this.isEcomV2 ? 'e-commerce-v2/error' : this.isBuildAndPrice ? 'build-and-price/error' : '/error';
      this.$router.push(route);
    },
  },
};

export const ctaChoiceMixin = {
  data() {
    return {};
  },
  methods: {
    returnCtaProduct(index, overrideToDefault, adSlots, reviewsCount) {
      const product = index % 2 === 0 ? 'trade' : 'credit';

      // force return if overridden or not subscribed to product
      // overridden if it's the last array index or index of last ad. (short returns will always end with an ad.)
      if (overrideToDefault && (index === reviewsCount - 1 || index === adSlots[1])) {
        return 'default';
      }
      return product;
    },
  },
};

export const avErrorMixin = {
  data() {
    return {
      avErrors: {
        phoneNumber: '',
        emailAddress: '',
      },
    };
  },
  methods: {
    handleServerSideError(error) {
      if (error.response && error.response.status === 400 && error.response.data && !error.response.data.success) {
        // The error message is the unique value
        switch (error.response.data.errors) {
          case 'Error invalid phone number entered.':
            this.avErrors.phoneNumber = this.$t('message.common.invalidPhoneError');
            break;
          case 'Error invalid email address entered.':
            this.avErrors.emailAddress = this.$t('message.common.invalidEmailError');
            break;
          default:
        }
        return true;
      }
      // No error found
      this.avErrors = {
        phoneNumber: '',
        emailAddress: '',
      };
      return false;
    },
  },
};

export const homeOwnershipMixin = {
  data() {
    return {
      ownership: [
        {
          value: 'BuyingHome',
          label: this.$t('message.credit.application.ownershipOptions.mortgage'),
        },
        {
          value: 'LeasingRenting',
          label: this.$t('message.credit.application.ownershipOptions.rent'),
        },
        {
          value: 'OwnsHomeOutright',
          label: this.$t('message.credit.application.ownershipOptions.freeAndClear'),
        },
        {
          value: 'LivingWithRelatives',
          label: this.$t('message.credit.application.ownershipOptions.parents'),
        },
        {
          value: 'OwnsBuyingMobileHome',
          label: this.$t('message.credit.application.ownershipOptions.mobileHome'),
        },
        {
          value: 'ReserveHousing',
          label: this.$t('message.credit.application.ownershipOptions.reserveHousing'),
        },
        {
          value: 'Unknown',
          label: this.$t('message.credit.application.ownershipOptions.other'),
        },
      ],
    };
  },
};

export const enumMixin = {
  data() {
    return {
      enums: Enums,
    };
  },
};

export const modalMethods = {
  methods: {
    async closeModal(forceExit) {
      // call update lead and close lead now
      this.$store.commit('SET_LOADING', true);
      this.$store.commit('SET_CLOSING', false);

      try {
        if (this.$store.getters['lead/leadIsActive']) {
          await this.$store.dispatch('lead/updateLead');
          await this.$store.dispatch('lead/completeLead');
        }
      } catch (err) {
        throw err;
      } finally {
        // event origin doesn't matter, as parent will always be customer site
        window.parent.postMessage(forceExit ? 'forceExit' : 'readyToClose', '*');
        this.$store.commit('SET_LOADING', false);
      }
    },
    async showCloseDialog() {
      // show confirm modal
      this.$store.commit('SET_CLOSING', true);
    },
  },
};

export const mediaQuery = {
  data() {
    return {
      currentScreenMediaQuery: 'mobile',
    };
  },
  computed: {
    isMobileScreenSize() {
      return this.currentScreenMediaQuery === 'mobile';
    },
    isDesktopScreenSize() {
      return this.currentScreenMediaQuery === 'desktop';
    },
  },
  methods: {
    getMediaQuery() {
      this.currentScreenMediaQuery = window.matchMedia('(min-width: 576px)')?.matches ? 'desktop' : 'mobile';
    },
  },
  mounted() {
    window.addEventListener('resize', this.getMediaQuery, false);
    this.getMediaQuery();
  },
  destroyed() {
    window.removeEventListener('resize', this.getMediaQuery, false);
  },
};

export const spotlightMixin = {
  computed: {
    ...mapGetters({
      vendorList: 'spotlight/getVendorList',
      getProductList: 'spotlight/getProductList',
      getSpotlightCategories: 'spotlight/getSpotlightCategories',
    }),
  },
  methods: {
    getProductContent(product) {
      const returns = {
        [SpotlightConstants.categories.HIGHLIGHTS]: {
          title: '',
          text: '',
        },
        [SpotlightConstants.categories.PROTECTION]: {
          title: '',
          text: '',
        },
        [SpotlightConstants.categories.FEATURES]: {
          title: '',
          text: '',
        },
        [SpotlightConstants.categories.AWARDS_AND_RATINGS]: {
          title: '',
          text: '',
        },
        [SpotlightConstants.categories.INCENTIVES_AND_REBATES]: {
          title: '',
          text: '',
        },
      };

      switch (product.internalName) {
        default:
          returns[product.category].title = product.payload.product;
          returns[product.category].text = product.payload.description;
      }
      return returns[product.category];
    },
    isVendor(product) {
      return this.vendorList.some(vendor => product.internalName.includes(vendor));
    },
    getSelectedSpotlightCategory() {
      return this?.$route?.meta?.category;
    },
    getSelectedSpotlightProduct() {
      const pathArray = this.$route.path.split('/');
      // make sure that the last element of the path array exactly matches the product internalName.
      return this.getProductList(this.getSelectedSpotlightCategory()).find(product =>
        pathArray.find(matched => matched.toLowerCase() === product.internalName.toLowerCase())
      );
    },
  },
};

export const IncomeExpenses = {
  data() {
    return {
      annualIncome: cloneDeep(this.$store.state.user.financeDetails.annualIncome),
      monthlyIncome: cloneDeep(this.$store.state.user.financeDetails.monthlyIncome),
      hourlyWage: cloneDeep(this.$store.state.user.financeDetails.hourlyWage),
      hoursPerWeek: cloneDeep(this.$store.state.user.financeDetails.hoursPerWeek),
      monthlyPayment: cloneDeep(this.$store.state.user.financeDetails.monthlyPayment),
      carPayments: cloneDeep(this.$store.state.user.financeDetails.monthlyExpenses.carPayments),
      loanPayments: cloneDeep(this.$store.state.user.financeDetails.monthlyExpenses.loanPayments),
      personalLineOfCredit: cloneDeep(this.$store.state.user.financeDetails.monthlyExpenses.personalLineOfCredit),
      creditCardPayments: cloneDeep(this.$store.state.user.financeDetails.monthlyExpenses.creditCardPayments),
      downPayment: cloneDeep(this.$store.state.user.financeDetails.downPayment),
    };
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    computedAnnualIncome() {
      if (this.incomeDetailsMethod === 'monthly') {
        return this.monthlyIncome * 12;
      }
      if (this.incomeDetailsMethod === 'hourly') {
        return this.hourlyWage * this.hoursPerWeek * 52;
      }
      return this.annualIncome;
    },
    incomeDetailsMethod: {
      get() {
        const { incomeDetailsMethod } = this.$store.state.user.financeDetails;
        if (incomeDetailsMethod !== null) {
          return incomeDetailsMethod;
        }
        return 'annual';
      },
      set(value) {
        this.$store.commit('user/SET_INCOME_DETAILS_METHOD', value);
      },
    },
    incomeDetailsMethodOptions() {
      return this.$t('message.credit.incomeAndMonthlyExpenses.incomeFrequencyOptions');
    },
    dollarMaskType() {
      return this.languageCode === 'fr-CA' ? 'frenchInt' : 'moneyInt';
    },
  },
  methods: {
    updateIncome() {
      switch (this.incomeDetailsMethod) {
        case 'hourly':
          this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['hourlyWage', this.hourlyWage]);
          this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['hoursPerWeek', this.hoursPerWeek]);
          break;
        case 'monthly':
          this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['monthlyIncome', this.monthlyIncome]);
          break;
        default:
          this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['annualIncome', this.annualIncome]);
      }
      this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['grossIncome', this.computedAnnualIncome]);
    },
    updateMortgageExpense() {
      this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['monthlyPayment', this.monthlyPayment]);
    },
    updateDownPayment() {
      this.$store.commit('user/SET_FINANCE_DETAILS_DATA', ['downPayment', this.downPayment]);
    },
    updateOtherExpenses() {
      this.$store.commit('user/SET_MONTHLY_EXPENSES', ['carPayments', this.carPayments]);
      this.$store.commit('user/SET_MONTHLY_EXPENSES', ['loanPayments', this.loanPayments]);
      this.$store.commit('user/SET_MONTHLY_EXPENSES', ['personalLineOfCredit', this.personalLineOfCredit]);
      this.$store.commit('user/SET_MONTHLY_EXPENSES', ['creditCardPayments', this.creditCardPayments]);
    },
  },
};

export const formMixin = {
  computed: {
    birthDateValidationRule() {
      const todaysDate = moment().format('YYYY/MM/DD');
      const minimumDate = moment('01/01/1900', 'DD/MM/YYYY').format('YYYY/MM/DD');

      return `required|length:10|date_format:yyyy/MM/dd|date_between:${minimumDate},${todaysDate},[]`;
    },
  },
};

export const tradePersonalInfoMixin = {
  computed: {
    ...mapGetters('business', [
      'mobileVerificationEnabled',
      'getPhoneNumberVerificationArray',
      'tradeAcquireAdditionalVehicleDetails',
    ]),
    ...mapGetters(['getCurrentProduct']),
    isAcquire() {
      return this.$store.getters.getCurrentProduct === AVRProducts.ACQUIRE;
    },
  },
  methods: {
    async processPersonalInfo(isUnstructuredTrade = false) {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead');
        try {
          if (!isUnstructuredTrade) {
            await this.$store.dispatch('trade/getReport');
          }
          switch (this.getCurrentProduct) {
            case AVRProducts.ACQUIRE:
              this.$store.commit('trade/SET_LEAD_ACQUIRE_VEHICLE');
              break;
            default:
              this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
          }
          try {
            await this.$store.dispatch('lead/updateLead');
            if (this.tradeAcquireAdditionalVehicleDetails) {
              this.$router.push({ path: `${this.getProductBasePath()}/additional-vehicle-details` });
              return;
            }
            if (this.mobileVerificationEnabled) {
              this.$router.push({ path: `${this.getProductBasePath()}/mobile-verification` });
            } else {
              this.$router.push({ path: `${this.getProductBasePath()}/report` });
            }
          } catch (err) {
            this.$log(`Error in ${this.getCurrentProduct} personal form - Update Lead`, err);
            this.$router.push({ path: `${this.getProductBasePath()}/error` });
          }
        } catch (error) {
          this.$log(`Error on getting ${this.getCurrentProduct} report!`, error);
          this.$router.push({ path: `${this.getProductBasePath()}/report` });
        }
      } catch (err) {
        if (!this.handleServerSideError(err)) {
          this.$log(`Error in ${this.getCurrentProduct} Personal Info Form - Create lead`, err);
          this.$router.push({ path: `${this.getProductBasePath()}/error` });
        }
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};

export const creditRangesMixin = {
  data() {
    const locale = this.$route.query.language;
    return {
      creditRanges: [
        {
          content: `<b>801 — 900</b>&nbsp;&nbsp;${this.$t('message.credit.categories.gradeA', locale)}`,
          value: 'A',
          range: '801 — 900',
        },
        {
          content: `<b>761 — 800</b>&nbsp;&nbsp;${this.$t('message.credit.categories.gradeB', locale)}`,
          value: 'B',
          range: '761 — 800',
        },
        {
          content: `<b>721 — 760</b>&nbsp;&nbsp;${this.$t('message.credit.categories.gradeC', locale)}`,
          value: 'C',
          range: '721 — 760',
        },
        {
          content: `<b>641 — 720</b>&nbsp;&nbsp;${this.$t('message.credit.categories.gradeD', locale)}`,
          value: 'D',
          range: '641 — 720',
        },
        {
          content: `<b>350 — 640</b>&nbsp;&nbsp;${this.$t('message.credit.categories.gradeE', locale)}`,
          value: 'E',
          range: '350 — 640',
        },
      ],
    };
  },
  methods: {
    getCreditRangeRange(creditGrade) {
      const res = creditGrade ? this.creditRanges.filter(item => creditGrade === item.value) : null;
      return res && res.length === 1 ? res[0].range : null;
    },
  },
};
